import { RulesPage } from '@/components/rules/RulesPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/rules/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <RulesPage />;
}
